import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Avatar,
  Menu,
  MenuItem,
  useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/images/tks_modern_logo.svg";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LogoutIcon from "@mui/icons-material/Logout";
import GroupIcon from "@mui/icons-material/Group"
import BadgeIcon from '@mui/icons-material/Badge';
import FileDownloadIcon from '@mui/icons-material/FilePresent';





const Header = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const { user, logout } = useAuth();

  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobile, setMobile] = useState("");

  const toggleDrawer = (state) => () => {
    setOpenDrawer(state);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navLinks = [
    { title: "Home", path: "/" },
    { title: "Our People", path: "/our-people" },
    { title: "About Us", path: "/aboutus" },
    { title: "Leadership", path: "/leadership" },
    { title: "Gallery", path: "/gallery" }
  ];

  const handleNavigation = (path) => {
    if (path === "/our-people") {
      if (window.location.pathname === "/") {
        const section = document.getElementById("our-people-section");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        navigate("/");
        window.scrollTo(0, 0);
        setTimeout(() => {
          const section = document.getElementById("our-people-section");
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    } else {
      navigate(path);
      window.scrollTo(0, 0);
    }
    setOpenDrawer(false);
  };

  const storedUser = localStorage.getItem("first_name");
  const storedUserType = localStorage.getItem("user_type");
  const paymentStatus = localStorage.getItem("payment_status");
  const idCardStatus = localStorage.getItem("ID_Card");
  const userType =
    storedUserType === "user" && paymentStatus === "Paid" && idCardStatus === "Generated"
      ? "TKS Member"
      : storedUserType;
  localStorage.getItem("Payment_Status")

  const menuItemStyle = {
    color: "#FFFFFF",
    bgcolor: "#57511F",
    borderRadius: "10px",
    m: "6px 0",
    fontWeight: 500,
    '&:hover': {
      color: "#FFFFFF",
      bgcolor: "#57511F",
      transform: "scale(1.02)",
      boxShadow: "0px 2px 10px rgba(0,0,0,0.1)"
    }
  };
  const iconStyle = {
    fontSize: 20,
    color: "#FFFFFF",
    mr: 1
  };
  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#FAD707" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 0 }}>
          <Link to="/">
            <img src={logo} alt="Temple Logo" style={{ width: "60px", height: "auto" }} />
          </Link>
          <Box sx={{ color: '#E52029', fontWeight: 600, textAlign: 'left', fontSize: "12px" }}>
            <div>திருக்கடையூர்</div>
            <div>சேனைத்தலைவர்</div>
            <div>அறக்கட்டளை</div>
          </Box>
        </Box>
        {/* Desktop Navigation */}
        {!isMobile && (
          <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "left", gap: 3, ml: 5, }}>
            {navLinks.map((link, index) => (
              <Typography
                variant="body1"
                sx={{
                  textDecoration: "none",
                  color: "#000000",
                  fontWeight: 500,
                  fontSize: "20px%",
                  cursor: "pointer",
                  transition: "color 0.3s",
                  '&:hover': { color: "#E52029" }
                }}
                onClick={() => handleNavigation(link.path)}
              >
                {link.title}
              </Typography>
            ))}
          </Box>
        )}

        {/* User Profile Dropdown OR Login/Register Buttons */}
        {user ? (<>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
              <Button
                onClick={handleMenuOpen}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F8F9E9",
                  // background: 'linear-gradient(135deg, #B4AB57, #947F49)',
                  borderRadius: "50px",
                  padding: "4px 10px",
                  minWidth: 0,
                  color: "#57511F",
                  border: "2px solid #57511F",
                  textTransform: "none",
                  '&:hover': {
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Added box shadow on hover
                  }
                }}
              >
                <Avatar sx={{ border: "2px solid #57511F", bgcolor: "#FAD707", color: "#57511F", width: 32, height: 32, fontSize: 16 }}>
                  {storedUser?.charAt(0).toUpperCase()}
                </Avatar>
                <Typography sx={{ ml: 1, mr: 1, fontWeight: 500, display: anchorEl ? 'inline' : 'none' }}>
                  {storedUser}
                </Typography>
                <Box
                  sx={{
                    width: 0,
                    height: 0,

                    borderLeft: "6px solid transparent",
                    borderRight: "6px solid transparent",
                    borderTop: "6px solid  #57511F",
                    ml: 1,
                  }}
                />
              </Button>
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              PaperProps={{
                sx: {
                  backgroundColor: "#FAD707",
                  borderRadius: "12px",
                  mt: 1,
                  p: 1,
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
                }
              }}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={() => { navigate("/profile"); handleMenuClose(); }} sx={menuItemStyle}>
                <AccountCircleIcon sx={iconStyle} /> My Profile
              </MenuItem>
              <MenuItem onClick={() => { navigate("/membership"); handleMenuClose(); }} sx={menuItemStyle}>
                <BadgeIcon sx={iconStyle} />
                Membership ID
              </MenuItem>
              {(user?.role === "superuser" || user?.role === "admin") && (
                <MenuItem onClick={() => { navigate("/manageusers"); handleMenuClose(); }} sx={menuItemStyle}>
                  <GroupIcon sx={iconStyle} /> Manage Users
                </MenuItem>
              )}
              {user?.role === "superuser" && (
                <MenuItem onClick={() => { handleMenuClose(); }} sx={menuItemStyle}>
                  <FileDownloadIcon sx={iconStyle} /> Tally export data
                </MenuItem>
              )}
              <MenuItem onClick={() => { navigate("/receipt"); handleMenuClose(); }} sx={menuItemStyle}>
                <ReceiptIcon sx={iconStyle} /> Receipt
              </MenuItem>
              <MenuItem onClick={logout} sx={menuItemStyle}>
                <LogoutIcon sx={iconStyle} />Logout
              </MenuItem>
            </Menu>
          </Box>
        </>
        ) : (
          !isMobile && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="text"

                // Make it take full width
                sx={{
                  fontSize: "0.9rem",
                  padding: "4px 10px",
                  textTransform: "none",
                  color: "#000000",
                  justifyContent: "flex-start", // Align text to the left if desired
                  mb: 1 // Optional: adds some spacing below
                }}
                onClick={() => {
                  navigate("/register");
                  window.scrollTo(0, 0); // Scroll to top
                }}
              >
                New user
              </Button>

              <Button
                onClick={() => {
                  navigate("/login");
                  window.scrollTo(0, 0); // Scroll to top
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F8F9E9",
                  // background: 'linear-gradient(135deg, #B4AB57, #947F49)',
                  borderRadius: "50px",
                  padding: "4px 10px",
                  minWidth: 0,
                  color: "#57511F",
                  border: "2px solid #57511F",
                  textTransform: "none",
                  '&:hover': {
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Added box shadow on hover
                  }
                }}
              >
                Login
              </Button>
            </Box>
          )
        )}
        {isMobile && !user && (
          <IconButton onClick={toggleDrawer(true)} sx={{ color: "black" }}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>
      {/* Mobile Drawer (Side Menu) */}
      <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250, padding: 2 }}>
          {/* Close Button */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <img src={logo} alt="Temple Logo" style={{ width: "100px", height: "auto" }} />
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {navLinks.map((link, index) => (
              <ListItem button key={index} onClick={() => handleNavigation(link.path)}>
                <ListItemText primary={link.title} />
              </ListItem>
            ))}
          </List>
          <Divider />
          {user ? (
            <List>
              <ListItem button onClick={() => navigate("/profile")}>
                <ListItemText primary="My Profile" />
              </ListItem>
              <ListItem button onClick={() => navigate("/membership")}>
                <ListItemText primary="Membership ID" />
              </ListItem>
              <ListItem button onClick={() => navigate("/")}>
                <ListItemText primary="Logout" />
              </ListItem>
            </List>
          ) : (
            <List>
              <ListItem button onClick={() => handleNavigation("/register")}>
                <ListItemText primary="NEW USER" />
              </ListItem>
              <ListItem button onClick={() => handleNavigation("/login")}>
                <ListItemText primary="LOGIN" />
              </ListItem>
            </List>
          )}
        </Box>
      </Drawer>
    </AppBar>
  );
};
export default Header;